// extracted by mini-css-extract-plugin
export var chip = "_mp-0";
export var icon = "_mp-1";
export var remove = "_mp-2";
export var removeIcon = "_mp-3";